module.exports = __webpack_public_path__ + "assets/img/CW.c5aee758.svg";